export const getLoggedUser = (state) => state.auth.user
